import React from 'react';
import { ManageOrgStructureData } from '../data/useManageOrgStructure';
import { SimpleDialog } from '../../../../toolympus/components/primitives';
import { Divider, IconButton, List, ListItem, ListItemText, ListSubheader, Typography } from '@mui/material';
import { Visibility } from '@mui/icons-material';

interface Props {
  data: ManageOrgStructureData["editHidden"];
  doHideOrUnhide: ManageOrgStructureData["doHideOrUnhide"];
}

export const HiddenStructureNodesDialog = (props: Props) => {
  const { data, doHideOrUnhide } = props;

  if(!data.item) {
    return null;
  }

  return (
    <SimpleDialog
      {...data.dialog}
      dialogTitle="Скрытые элементы"
      save={() => {}}
      noSave
      noFullscreen
      cancelLabel="закрыть">
      
      {data.item.departments.length === 0 && data.item.employees.length === 0 ? (
        <Typography color="textSecondary" align="center" sx={{ p: 4 }}>
          Нет скрытых сотрудников или отделов.
        </Typography>
      ) : (
        <List disablePadding>
          {/* --- Departments --- */}
          {data.item.departments.length > 0 && (
            <>
              <ListSubheader disableSticky>Отделы</ListSubheader>
              {data.item.departments.map((dept) => (
                <ListItem
                  key={`hidden-dept-${dept._id}`}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      color="primary"
                      onClick={() => doHideOrUnhide({ kind: 'department', operation: 'unhide', item: dept })}
                    >
                      <Visibility />
                    </IconButton>
                  }
                >
                  <ListItemText primary={dept.title} />
                </ListItem>
              ))}
            </>
          )}

          {/* Separator if both exist */}
          {data.item.departments.length > 0 && data.item.employees.length > 0 && (
            <Divider component="li" />
          )}

          {/* --- Employees --- */}
          {data.item.employees.length > 0 && (
            <>
              <ListSubheader disableSticky>Сотрудники</ListSubheader>
              {data.item.employees.map((emp) => (
                <ListItem
                  key={`hidden-emp-${emp._id}`}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      color="primary"
                      onClick={() => doHideOrUnhide({ kind: 'employee', operation: 'unhide', item: emp })}
                    >
                      <Visibility />
                    </IconButton>
                  }
                >
                  <ListItemText primary={`${emp.last_name || ''} ${emp.first_name || ''}`.trim()} />
                </ListItem>
              ))}
            </>
          )}
        </List>
      )}
    </SimpleDialog>
  );
}


